/*
 * View for a single landlord
 */

define(["marionette", "./template/landlordModalTemplate.html"], function (
  Marionette,
  LandlordModalTemplate,
) {
  var LandlordModalView = {};

  LandlordModalView.landlordModalLayout = Marionette.Layout.extend({
    template: LandlordModalTemplate,
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    getLandlordName: function () {
      return this.$el.find("#landlordName").val().trim();
    },
    getTenantCapacity: function () {
      return parseInt(this.$el.find("#tenantCapacity").val());
    },
    getKnowledgebaseCapacity: function () {
      return parseInt(this.$el.find("#kbCapacity").val());
    },
    getResponseTypeCapacity: function () {
      return parseInt(this.$el.find("#responseTypeCapacity").val());
    },
    getTaskManagement: function () {
      return this.$el.find("#taskManagement").prop("checked");
    },
    getActionGroups: function () {
      return this.$el.find("#actionGroups").prop("checked");
    },
    getAgentAssist: function () {
      return this.$el.find("#agentAssist").prop("checked");
    },
    getAdHocReporting: function () {
      return this.$el.find("#adHocReporting").prop("checked");
    },
    getRecommendations: function () {
      return this.$el.find("#recommendations").prop("checked");
    },
    getCrossTouchPointAccess: function () {
      return this.$el.find("#crossTouchPointAccess").prop("checked");
    },
    getSiteMapAccess: function () {
      return this.$el.find("#siteMapAccess").prop("checked");
    },
    clearErrors: function () {
      this.$el.find("#landlordNameError").html("");
      this.$el.find("#tenantCapacityError").html("");
      this.$el.find("#kbCapacityError").html("");
      this.$el.find("#responseTypeCapacityError").html("");
      this.$el.find("#taskManagementError").html("");
      this.$el.find("#actionGroupsError").html("");
      this.$el.find("#agentAssistError").html("");
      this.$el.find("#adHocReportingError").html("");
      this.$el.find("#recommendationsError").html("");
      this.$el.find("#crossTouchPointAccessError").html("");
      this.$el.find("#siteMapAccessError").html("");
    },
    nameError: function (errorMessage) {
      this.$el
        .find("#landlordNameError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    tenantCapacityError: function (errorMessage) {
      this.$el
        .find("#tenantCapacityError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    kbCapacityError: function (errorMessage) {
      this.$el
        .find("#kbCapacityError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    responseTypeCapacityError: function (errorMessage) {
      this.$el
        .find("#responseTypeCapacityError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    taskManagementError: function (errorMessage) {
      this.$el
        .find("#taskManagementError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    actionGroupsError: function (errorMessage) {
      this.$el
        .find("#actionGroupsError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    agentAssistError: function (errorMessage) {
      this.$el
        .find("#agentAssistError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    adHocReportingError: function (errorMessage) {
      this.$el
        .find("#adHocReportingError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    recommendationsError: function (errorMessage) {
      this.$el
        .find("#recommendationsError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    crossTouchPointAccessError: function (errorMessage) {
      this.$el
        .find("#crossTouchPointAccessError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    siteMapAccessError: function (errorMessage) {
      this.$el
        .find("siteMapAccessError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return LandlordModalView;
});
